export const downloadFile = (blob: Blob, filename: string) => {
  const href = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = href
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()

  if (typeof link.download === 'undefined') {
    link.setAttribute('target', '_blank')
  }

  document.body.removeChild(link)
  URL.revokeObjectURL(href)
}

export function downloadCsv(filename: string, text: any) {
  var element = document.createElement('a')
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text))
  element.setAttribute('download', filename)

  element.style.display = 'none'
  document.body.appendChild(element)

  element.click()

  document.body.removeChild(element)
}
